import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Card } from '../../Card/Card.es.js';

const ButtonCardCore = ({ className, variant = 'primary/base', disabled, children })=>jsx(Card, {
        className: classNames('cb-button-card', className),
        clickable: "primary",
        "data-testid": "button-card",
        disabled: disabled,
        variant: variant,
        children: children
    });
ButtonCardCore.displayName = 'ButtonCard.Core';

export { ButtonCardCore, ButtonCardCore as default };
//# sourceMappingURL=ButtonCard.Core.es.js.map
